import React, { useEffect, useState } from "react";

export default function DesignsPanel({ apiUrl, onLoadDesign }) {
  const [designs, setDesigns] = useState([]);

  useEffect(() => {
    const loadLocal = () => {
      const saved = JSON.parse(localStorage.getItem("designs") || "[]");
      setDesigns(saved);
    };
    loadLocal();

    // if apiUrl provided, try fetch remote list (best-effort)
    const fetchRemote = async () => {
      if (!apiUrl) return;
      try {
        const res = await fetch(`${apiUrl}/api/designs`);
        if (!res.ok) return;
        const data = await res.json();
        // merge remote and local (remote last)
        setDesigns(prev => {
          const combined = [...prev];
          data.forEach(d => {
            if (!combined.some(x => x.id === d.id)) combined.push(d);
          });
          return combined;
        });
      } catch (e) {
        // ignore
      }
    };
    fetchRemote();
  }, [apiUrl]);

  const loadDesign = (d) => {
    if (onLoadDesign) onLoadDesign(d);
  };

  const deleteDesign = (d) => {
    // delete locally if present
    const saved = JSON.parse(localStorage.getItem("designs") || "[]");
    const next = saved.filter(x => x.id !== d.id);
    localStorage.setItem("designs", JSON.stringify(next));
    setDesigns(prev => prev.filter(x => x.id !== d.id));
  };

  return (
    <div className="mb-4">
      <h4 className="font-semibold mb-2">My Designs</h4>
      <div className="space-y-2 max-h-64 overflow-auto">
        {designs.length === 0 && <div className="text-sm text-gray-500">No saved designs</div>}
        {designs.map(d => (
          <div key={d.id} className="p-2 border rounded flex items-center justify-between">
            <div>
              <div className="font-medium text-sm">{d.name || 'Untitled'}</div>
              <div className="text-xs text-gray-500">Status: {d.submission_status || 'local'}</div>
            </div>
              <div className="flex items-center gap-2">
              <button type="button" onClick={() => loadDesign(d)} className="px-2 py-1 border rounded text-sm">Load</button>
              <button type="button" onClick={() => deleteDesign(d)} className="px-2 py-1 border rounded text-sm">Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

